import { withTheme } from "styled-components";
import DataSet from "@antv/data-set";
import G2 from "@antv/g2";
import React, { Component } from "react";

import ColorUtil from "../../util/ColorUtil";

class PopularGraph extends Component {
    state = {}

    componentDidMount = () => {
    	const { data, id, max, theme, visualColorKey } = this.props;
    	const ds = new DataSet();
    	const dv = ds.createView().source(data);
    	dv.source(data).transform({
    		type: "sort",
    		callback(a, b) {
    			return a.value - b.value;
    		},
    	});
    	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
    	this.chart = new G2.Chart({
    		container: id,
    		forceFit: true,
    		height: max ? 600 : 250,
    		padding: [10, 50, 10, 100],
    	});
    	this.chart.axis("value", false);
    	this.chart.scale("value", {
    		range: [0, 1]
    	});
    	this.chart.source(dv);
    	this.chart.coord().transpose();
    	this.chart.interval().position("topic*value").style({ fill: color });
    	this.chart.render();
    	window.dispatchEvent(new Event("resize"));
    }


    render() {
    	const { id } = this.props;
    	return (
    		<div id={id}></div>
    	);
    }
}

export default withTheme(PopularGraph);


// WEBPACK FOOTER //
// ./src/components/report/PopularGraph.js